import { Component, AfterViewInit, ViewChild, Input } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { ResidencyFacultyModel } from '@shared/models/data/residency-faculty-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { SessionService } from '@shared/services/session.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RemoveFacultyDialogComponent } from '../remove-faculty-dialog/remove-faculty-dialog.component';
import { FacultySearchDialogComponent } from '../faculty-search-dialog/faculty-search-dialog.component';

@Component({
  selector: 'aaos-faculty-table',
  templateUrl: './faculty-table.component.html',
  styleUrls: ['./faculty-table.component.scss']
})
export class FacultyTableComponent implements AfterViewInit {

  editPrivileges = false;
  loading = true;
  dataSource: MatTableDataSource<ResidencyFacultyModel>;
  columnsToDisplay = ['firstName', 'lastName', 'emailAddress', 'dateAdded', 'actions'];
  @ViewChild(MatSort) sort: MatSort;
  @Input() faculty: ResidencyFacultyModel[];
  selectedFacultyMember: ResidencyFacultyModel;

  constructor(private authService: AuthService, private enrollService: EnrollmentService,
              private sessionService: SessionService, private dialog: MatDialog) {
    this.dataSource = new MatTableDataSource();
    this.enrollService.rosterChange.subscribe(() => {
      this.getFacultyData();
    });
    this.editPrivileges = this.authService.changeAuthorized();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.getFacultyData();
  }

  openFacultySearchDialog() {

     const dialogRef = this.dialog.open(FacultySearchDialogComponent, this.getModalConfig());
  }

  openRemoveFacultyDialog(facultyMember: ResidencyFacultyModel) {
    this.selectedFacultyMember = facultyMember;
    this.dialog.open(RemoveFacultyDialogComponent, this.getModalConfig());
  }

  getModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: this.selectedFacultyMember,
    } as MatDialogConfig;
  }

  getFacultyData() {
    this.loading = true;
    this.enrollService.getFaculty(this.sessionService.getInstitutionId()).subscribe(fac => {
      this.faculty = fac;
      this.dataSource.data = this.faculty;
      this.loading = false;
    });
  }
}
